import React from "react"
import theme from "./../../../Theme/Theme"
import { Div, Text, Icon } from "atomize";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import ReactTooltip from "react-tooltip";

const Wrapper = styled(NavLink)`
  height: 40px;
  border: 1px solid ${theme.colors.primary};	
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  margin: 2rem 0;
  
  transition: all .25s ease-in-out;
  
  &:hover, &:focus {
    background-color: ${theme.colors.primary};
    span {
      color: white;
    }
  }
`;

const LinkText = styled.span`
  color: ${theme.colors.primary};	
  font-family: Inter;	
  font-size: 14px;	
  font-weight: 500;	
  line-height: 24px;	
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
  transition: all .25s ease-in-out;
`;


const WrapperPrimary = styled(NavLink)`
  height: 40px;
  background-color: ${theme.colors.primary};	
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  margin: 1rem 0 0 0;
  
  transition: background-color .25s ease-in-out;
  
  svg {
    transition: transform .25s ease-in-out;
  }
  
  &:hover {
    background-color: ${theme.colors.secondary};
    svg {
      transform: scale(1.05);
    }
  }
  &:active, &:focus {
    background-color: ${theme.colors.primary};	
    svg {
      transform: scale(1);
    }
  }
`;

const PrimaryLinkText = styled.span`
  color: white;	
  font-family: Inter;	
  font-size: 14px;	
  font-weight: 500;	
  line-height: 24px;	
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
`;

const WrapperPrimaryButton = styled.button`

  opacity: ${ props => props.disabled ? '.5' : '1' };
  pointer-events: ${ props => props.disabled ? 'none' : 'all' };
  
  height: 40px;
  background-color: ${theme.colors.primary};	
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  margin: 1rem 0 0 0;
  cursor: pointer;
  
  transition: background-color .25s ease-in-out;
  
  svg {
    transition: transform .25s ease-in-out;
  }
  
  &:hover {
    background-color: ${theme.colors.secondary};
    svg {
      transform: scale(1.05);
    }
  }
  &:active, &:focus {
    background-color: ${theme.colors.primary};	
    svg {
      transform: scale(1);
    }
  }
`;

const WrapperButton = styled.button`
  height: 40px;
  border: 1px solid ${theme.colors.grayDark};	
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 2rem;
  margin: 2rem 0;
  cursor: pointer;
  background-color: transparent;
  
  svg {
    transition: transform .25s ease-in-out;
  }
  
  &:hover {
    svg {
      transform: scale(1.05);
    }
  }
  &:active, &:focus {
    svg {
      transform: scale(1);
    }
  }
`;

const GrayLinkText = styled.span`
  color: ${theme.colors.grayDark};	
  font-family: Inter;	
  font-size: 14px;	
  font-weight: 500;	
  line-height: 24px;	
  text-align: center;
  overflow: hidden;
  white-space: nowrap;
`;


function SecondaryButton(props) {
  if (props.type === 'button') {
    return (
      <WrapperButton
        onClick={ () => props.action()}
      >
        {
          props.icon &&
          <Icon name={props.icon} size="20px" style={{ marginLeft: '-.5rem', marginRight: '.5rem'}} color={theme.colors.grayDark} />
        }
        <GrayLinkText>
          { props.text }
        </GrayLinkText>
      </WrapperButton>
    )
  }
  else {
    return (
      <Wrapper
        to={ `${props.url.replace('internal:', '')}`}
      >
        <LinkText>
          {props.text}
        </LinkText>
      </Wrapper>
    )
  }
}

function PrimaryButton(props) {
  if (props.type === 'button') {
    return (
      <div className={'primary-wrapper'} data-tip={props.tip ? props.tip : null }>
        {
          props.tip &&
          <ReactTooltip
            place={ props.tipPos ? props.tipPos : "bottom"} type="dark" effect="solid"
          />
        }
        <WrapperPrimaryButton
          onClick={ () => props.action()}
          disabled={ props.disabled }
        >
          {
            props.icon &&
            <Icon name={props.icon} size="20px" style={{ marginLeft: '-.5rem', marginRight: '.5rem'}} color={'white'} />
          }
          <PrimaryLinkText>
            { props.text }
          </PrimaryLinkText>
        </WrapperPrimaryButton>
      </div>
    )
  }
  else {
    return (
      <WrapperPrimary
        to={ `${props.url.replace('internal:', '')}`}
      >
        {
          props.back &&
          <Icon name={'LeftArrow'} size="20px" style={{ marginLeft: '-.5rem', marginRight: '.5rem'}} color={'white'} />
        }
        <PrimaryLinkText>
          { props.text }
        </PrimaryLinkText>
      </WrapperPrimary>
    )
  }
}



export { PrimaryButton, SecondaryButton }
